import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { BULLETIN_FEED_FILTERS, BulletinFeedFilter } from '@/types/admin/bulletins';
import { ADMIN_COLORS } from '@/constants/admin';

interface BulletinFeedTabsProps {
  activeFilter: BulletinFeedFilter;
  onFilterChange: (filter: BulletinFeedFilter) => void;
}

const tabs = [
  { key: BULLETIN_FEED_FILTERS.FEED, label: 'Feed' },
  { key: BULLETIN_FEED_FILTERS.SCHEDULED, label: 'Scheduled' },
  { key: BULLETIN_FEED_FILTERS.DRAFT, label: 'Draft' },
];

export const BulletinFeedTabs: React.FC<BulletinFeedTabsProps> = ({
  activeFilter,
  onFilterChange,
}) => {
  return (
    <View style={styles.container}>
      {tabs.map((tab) => (
        <TouchableOpacity
          key={tab.key}
          style={[
            styles.tab,
            activeFilter === tab.key && styles.activeTab,
          ]}
          onPress={() => onFilterChange(tab.key)}
        >
          <Text
            style={[
              styles.tabText,
              activeFilter === tab.key && styles.activeTabText,
            ]}
          >
            {tab.label}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
    borderRadius: 8,
    padding: 4,
    marginBottom: 16,
  },
  tab: {
    flex: 1,
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 6,
    alignItems: 'center',
    justifyContent: 'center',
  },
  activeTab: {
    backgroundColor: ADMIN_COLORS.PRIMARY,
  },
  tabText: {
    fontSize: 14,
    fontWeight: '500',
    color: ADMIN_COLORS.TEXT_SECONDARY,
  },
  activeTabText: {
    color: '#FFFFFF',
  },
});
